import { render } from "./AIAssistant.vue?vue&type=template&id=17b12c5a&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=17b12c5a&lang=css"
import "./AIAssistant.vue?vue&type=style&index=1&id=17b12c5a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b12c5a"]])

export default __exports__